import { api } from "@/utils/api";
import { sanitizePathParam } from "@/utils/sanitize";

export default class ParameterSourceRepository {
  async saveSources(
    infraId: number | string,
    parameterId: number | string,
    sources: Array<any>
  ): Promise<boolean> {
    const iid = sanitizePathParam(infraId);
    const pid = sanitizePathParam(parameterId);
    const result = await api.post(
      `/measurements/infrastructures/${iid}/parameters/${pid}/sources`,
      { sources }
    );
    return result.data.success === 1;
  }

  async deleteParameter(sourceId: number | string): Promise<boolean> {
    const sid = sanitizePathParam(sourceId);
    const result = await api.delete(`/measurements/sources/${sid}`);
    return result.data;
  }
}
